import React from 'react'
import { observer } from 'mobx-react'
import { Layout } from 'antd'

import styles from './index.scss'
import { SUPPOER_LOCALES } from '@locales/loader'
import { setCookie } from '@utils/index'
import { COOKIE_KEYS } from '@constants/index'

function Header() {
    return (
        <Layout.Header className={styles.header}>
            <div className={styles.logo}>Costaoeste</div>

            <div style={{ zIndex: 3000, display: 'flex' }}>
                {SUPPOER_LOCALES.map(l => (
                    <a style={{ color: 'white', fontWeight: 'bold', marginLeft: '10px' }} onClick={() => onSelectLocale(l.value)}
                       key={l.value} value={l.value}>
                        {l.name}
                    </a>
                ))}
            </div>

        </Layout.Header>
    )
}

function onSelectLocale(val: string) {
    setCookie(COOKIE_KEYS.LANG, val)
    location.reload()
}


export default observer(Header)
